export const GLOSSARY = [
  {
    "key": 1,
    "value": "Access Policy",
    "description": "A set of rules that specifies the permissions for an identity (IAM User, IAM Role, IAM Group) or resource it is associated with."
  },
  {
    "key": 2,
    "value": "Activation Function",
    "description": "A mathematical function within a neural network that introduces nonlinearity and determines the output of a neuron based on its input."
  },
  {
    "key": 3,
    "value": "Accuracy",
    "description": "A performance metric that measures the proportion of correct predictions (positive and negative) made by a model out of all the predictions."
  },
  {
    "key": 4,
    "value": "Algorithm",
    "description": "A set of mathematical instructions or rules that a computer system uses to analyze data, identify patterns, and make predictions based on that data."
  },
  {
    "key": 5,
    "value": "All at Once Model Deployment",
    "description": "A deployment strategy where a new version of your machine learning model is simultaneously deployed to all instances within your environment, meaning all servers are updated at the same time, potentially causing a brief period of downtime while the update occurs; this is considered the fastest deployment method but can be disruptive if downtime is not acceptable."
  },
  {
    "key": 6,
    "value": "Amazon Athena",
    "description": "A serverless, interactive query service within AWS that allows users to analyze large datasets stored in Amazon S3 using standard SQL queries."
  },
  {
    "key": 7,
    "value": "Amazon Bedrock",
    "description": "A fully managed AWS service that allows developers to easily build generative AI applications by providing access to a variety of high-performing foundation models (FMs) from leading AI companies."
  },
  {
    "key": 8,
    "value": "Amazon CloudWatch",
    "description": "A service that monitors and manages AWS resources and applications by providing insights into application performance, operational health, and resource utilization."
  },
  {
    "key": 9,
    "value": "Amazon Comprehend",
    "description": "A managed AWS machine learning service that utilizes natural language processing (NLP) to extract insights and meaning from text data."
  },
  {
    "key": 10,
    "value": "Amazon Data Firehose",
    "description": "A fully managed AWS service that allows you to easily capture, transform, and deliver large volumes of real-time streaming data from various sources to data stores like Amazon S3, Redshift, OpenSearch Service, and other analytics tools."
  },
  {
    "key": 11,
    "value": "Amazon DynamoDB",
    "description": "A fully managed, serverless NoSQL database service within AWS that provides fast, scalable data storage."
  },
  {
    "key": 12,
    "value": "Amazon Elastic File System (EFS)",
    "description": "A fully managed, scalable file storage service that allows multiple EC2 instances to access and share data for machine learning tasks, providing a flexible and reliable way to store large datasets used for training and inference, without needing to manually provision or manage file storage capacity."
  },
  {
    "key": 13,
    "value": "Amazon Elastic Block Storage (EBS)",
    "description": "A service that provides persistent, high-performance block storage which can be attached to Amazon EC2 instances. bgloss.indd Page 393 09 Apr 2025"
  },
  {
    "key": 14,
    "value": "Amazon FSx for Lustre",
    "description": "A fully managed, high-performance file system service on AWS, specifically designed for demanding workloads like machine learning, where fast data access is crucial, allowing users to quickly process large datasets with low latency and high throughput."
  },
  {
    "key": 15,
    "value": "Amazon Kinesis Data Streams",
    "description": "A fully managed AWS service that allows you to collect, process, and analyze large volumes of real-time data streams, making it a crucial tool for machine learning applications that require continuous data ingestion and near-instantaneous analysis, such as anomaly detection, live sentiment analysis, and real-time predictive modeling."
  },
  {
    "key": 16,
    "value": "Amazon Lex",
    "description": "AWS service that allows developers to build conversational interfaces for applications using voice and text."
  },
  {
    "key": 17,
    "value": "Amazon Managed Service for Apache Flink",
    "description": "A fully managed AWS service that allows users to build and run real-time stream processing applications using the open-source Apache Flink framework."
  },
  {
    "key": 18,
    "value": "Amazon Managed Streaming for Apache Kafka (MSK)",
    "description": "A fully managed AWS service that helps users build and run applications that use Apache Kafka to process streaming data."
  },
  {
    "key": 19,
    "value": "Amazon Managed Workflows for Apache Airflow (MWAA)",
    "description": "A fully managed service that uses Apache Airflow, an open-source tool for automating workflows."
  },
  {
    "key": 20,
    "value": "Amazon Personalize",
    "description": "A fully managed machine learning service on AWS that allows developers to easily create personalized recommendations for users on their applications, without requiring extensive machine learning expertise."
  },
  {
    "key": 21,
    "value": "Amazon Polly",
    "description": "A cloud service within AWS that uses machine learning to convert written text into natural-sounding speech."
  },
  {
    "key": 22,
    "value": "Amazon Relational Database Service (RDS)",
    "description": "A managed cloud service that allows users to easily set up, operate, and scale a relational database, like Microsoft SQL Server, MySQL or PostgreSQL."
  },
  {
    "key": 23,
    "value": "Amazon Rekognition",
    "description": "A cloud-based image and video analysis service offered by AWS that uses machine learning to identify objects, scenes, people, text, and activities within images and videos."
  },
  {
    "key": 24,
    "value": "Amazon SageMaker AI",
    "description": "A fully managed machine learning (ML) service that helps users build, train, evaluate, deploy, and monitor ML models in AWS."
  },
  {
    "key": 25,
    "value": "Amazon SageMaker Clarify",
    "description": "An Amazon SageMaker AI service that offers both bias detection and model explainability capabilities within the ML workflow."
  },
  {
    "key": 26,
    "value": "Amazon SageMaker Data Wrangler",
    "description": "A visual tool within Amazon SageMaker AI that simplifies the process of data preparation and feature engineering for machine learning by allowing users to easily import, clean, transform, and visualize data from various sources through a user interface. bgloss.indd Page 394 09 Apr 2025"
  },
  {
    "key": 27,
    "value": "Amazon SageMaker Debugger",
    "description": "An Amazon SageMaker AI service that provides insights into the training process. Amazon SageMaker Debugger enables monitoring, debugging, and optimizing machine learning models in real time. It automatically captures and analyzes key training metrics and parameters, helping users identify issues such as overfitting, vanishing gradients, or resource bottlenecks, ultimately streamlining the development of efficient and accurate models."
  },
  {
    "key": 28,
    "value": "Amazon SageMaker Feature Store",
    "description": "An Amazon SageMaker AI service that stores, manages, and shares machine learning (ML) features."
  },
  {
    "key": 29,
    "value": "Amazon SageMaker Ground Truth",
    "description": "An Amazon SageMaker AI service that allows users to efficiently label large datasets with human annotations, creating high-quality “ground truth” training data for machine learning models."
  },
  {
    "key": 30,
    "value": "Amazon SageMaker JumpStart",
    "description": "An Amazon SageMaker AI service that acts as a machine learning (ML) hub, offering a collection of pre-trained models, built-in algorithms, and solution templates to quickly get users started with various ML tasks like text classification, image recognition, and text generation, allowing them to readily access and deploy models without needing to train them from scratch."
  },
  {
    "key": 31,
    "value": "Amazon SageMaker Model Monitor",
    "description": "An Amazon SageMaker AI service that automatically monitors the quality of machine learning models deployed in production, alerting users when issues like data quality degradation or model performance drift occur, essentially allowing for continuous tracking of model health and performance in real time."
  },
  {
    "key": 32,
    "value": "Amazon SageMaker Model Registry",
    "description": "An Amazon SageMaker AI service that helps manage the end-to-end lifecycle of machine learning models. Amazon SageMaker Model Registry enables teams to register, version, and catalog models systematically. It provides a centralized repository for storing model metadata, tracking changes, and streamlining deployment processes, making it easier to govern and collaborate on machine learning projects."
  },
  {
    "key": 33,
    "value": "Amazon SageMaker Neo",
    "description": "An Amazon SageMaker AI service that enables models to run efficiently on both cloud instances and supported edge devices. By automatically compiling and tuning models for specific hardware platforms, Amazon SageMaker Neo improves performance without sacrificing accuracy, reducing the need for manual optimization, and streamlining deployment across diverse hybrid environments."
  },
  {
    "key": 34,
    "value": "Amazon SageMaker Pipelines",
    "description": "An Amazon SageMaker AI service that allows users to build, automate, and scale end-to-end machine learning (ML) workflows by orchestrating different steps like data processing, model training, tuning, evaluation, deployment, and monitoring."
  },
  {
    "key": 35,
    "value": "Amazon SageMaker Role Manager",
    "description": "An Amazon SageMaker AI service that allows administrators to easily define and manage access permissions for different user personas involved in machine learning activities."
  },
  {
    "key": 36,
    "value": "Amazon SageMaker Studio",
    "description": "An Amazon SageMaker AI service that provides a unified integrated development environment (IDE) with a comprehensive workspace for building, training, evaluating, debugging, deploying, and monitoring machine learning models. It streamlines bgloss.indd Page 395 09 Apr 2025 the entire machine learning workflow by integrating tools for data preparation, model creation, and collaboration, enabling ML engineers and developers to work more efficiently in a single environment."
  },
  {
    "key": 37,
    "value": "Amazon SageMaker Training Job",
    "description": "A process within Amazon SageMaker AI where a machine learning model is trained using specified algorithms, datasets, and computing resources, allowing users to scale their model training without managing the underlying infrastructure."
  },
  {
    "key": 38,
    "value": "Amazon Simple Storage Service (S3)",
    "description": "A cloud-based object storage service within AWS that allows users to store and retrieve large amounts of data, making it a crucial component for machine learning applications on AWS, as it provides a scalable and highly available place to store training data, model artifacts, and results for machine learning algorithms."
  },
  {
    "key": 39,
    "value": "Amazon Textract",
    "description": "A fully managed machine learning service offered by AWS that automatically extracts text, handwriting, and structured data (like tables and forms) from scanned documents, images, and PDFs."
  },
  {
    "key": 40,
    "value": "Amazon Transcribe",
    "description": "A fully managed service within AWS that uses machine learning to convert spoken audio into text."
  },
  {
    "key": 41,
    "value": "Amazon Translate",
    "description": "A fully managed service within AWS that uses deep learning to translate text between languages."
  },
  {
    "key": 42,
    "value": "Asynchronous Inference",
    "description": "A model deployment option within Amazon SageMaker AI where incoming prediction requests are queued and processed asynchronously."
  },
  {
    "key": 43,
    "value": "AUC ROC (Area Under the Receiver Operating Characteristic Curve)",
    "description": "A metric used to evaluate the performance of a binary classification model, indicating how well it can distinguish between positive and negative classes, with a higher AUC value signifying better predictive ability."
  },
  {
    "key": 44,
    "value": "Autoscaling Endpoint",
    "description": "A technique to ensure deployed machine learning models can handle varying levels of traffic efficiently by scaling horizontally (scale-in, scale-out) the instances responsible for serving incoming inference requests."
  },
  {
    "key": 45,
    "value": "AWS CloudTrail",
    "description": "A service that tracks user activity and API usage for AWS accounts. It helps with security monitoring, compliance, and troubleshooting."
  },
  {
    "key": 46,
    "value": "AWS DataSync",
    "description": "A fully managed service within AWS that allows for the automated and efficient transfer of large amounts of data between different storage locations, including on-premises storage, AWS storage such as Amazon S3, Amazon EFS, the Amazon FSx family of services, as well as between other cloud storage providers and AWS."
  },
  {
    "key": 47,
    "value": "AWS Glue",
    "description": "A fully managed extract, transform, and load (ETL) service that makes it easy to prepare and load data for analytics and machine learning."
  },
  {
    "key": 48,
    "value": "AWS Glue DataBrew",
    "description": "A visual data preparation tool within AWS that allows users to clean, normalize, and transform data for machine learning (ML) analysis without writing any code. bgloss.indd Page 396 09 Apr 2025"
  },
  {
    "key": 49,
    "value": "AWS Identity and Access Management (IAM)",
    "description": "A service that helps you securely control access to AWS resources. With IAM, you can manage permissions that control which AWS resources users can access. You use IAM to control who is authenticated (signed in) and authorized (has permissions) to use resources."
  },
  {
    "key": 50,
    "value": "AWS Step Functions",
    "description": "A serverless workflow orchestration service that allows you to design and manage complex machine learning pipelines by visually connecting different steps like data preprocessing, model training, evaluation, and deployment."
  },
  {
    "key": 51,
    "value": "Backpropagation",
    "description": "A fundamental algorithm used to train neural networks by calculating and adjusting the network’s weights based on the difference between the predicted output and the actual target output, essentially allowing the model to “learn” from its errors and improve its accuracy over time."
  },
  {
    "key": 52,
    "value": "Baking Period",
    "description": "In a blue/green model deployment, refers to a set amount of time to monitor the new model instances (green fleet) before proceeding to the next deployment stage. If any of the pre-specified alarms trip during any baking period, then all endpoint traffic rolls back to the old model instances (blue fleet). The baking period helps you build confidence in your model update before making the (inference request) traffic shift permanent."
  },
  {
    "key": 53,
    "value": "Batch Transform",
    "description": "A feature within Amazon SageMaker AI that allows users to run large-scale batch inferences on large datasets stored in Amazon S3."
  },
  {
    "key": 54,
    "value": "Bayesian Search",
    "description": "A technique also called “Bayesian optimization,” which is a method for efficiently finding the best hyperparameters for a machine learning model by building a probabilistic model of the objective function and iteratively selecting the most promising hyperparameter combinations to evaluate. Amazon SageMaker AI Automatic Model Tuning (AMT) uses Bayesian search by default."
  },
  {
    "key": 55,
    "value": "Bias",
    "description": "A systematic error within a model where predictions are consistently skewed toward a particular group or outcome, often due to imbalances or underrepresentation in the training data, leading to unfair or inaccurate results when applied to diverse situations."
  },
  {
    "key": 56,
    "value": "Binning",
    "description": "A data preprocessing technique where continuous numerical values are grouped into a smaller number of discrete ranges called “bins,” essentially transforming numerical data into categorical data."
  },
  {
    "key": 57,
    "value": "Binary Encoding",
    "description": "A technique used to convert categorical data into binary format by assigning a unique binary code to each category."
  },
  {
    "key": 58,
    "value": "BlazingText",
    "description": "An Amazon SageMaker AI built-in algorithm that is designed to efficiently generate word embeddings using the Word2Vec method, allowing for fast and scalable text classification tasks. bgloss.indd Page 397 09 Apr 2025"
  },
  {
    "key": 59,
    "value": "Blue/Green Model Deployment",
    "description": "A deployment strategy where you maintain two identical production environments, one called “blue” representing the currently running model, and another called “green” which is used to deploy a new version of the model; once the new model is tested and validated in the green environment, you switch live traffic from the blue to the green environment, effectively updating the production model with minimal downtime and the ability to quickly roll back if issues arise."
  },
  {
    "key": 60,
    "value": "Canary Model Deployment",
    "description": "A strategy where a new version of a machine learning model is gradually rolled out to a small subset of users (the “canary”) before fully deploying it to the entire user base, allowing for close monitoring and quick rollback if any issues arise."
  },
  {
    "key": 61,
    "value": "Categorical Data",
    "description": "Data that can be divided into distinct categories or groups, represented by labels or names, rather than numerical values."
  },
  {
    "key": 62,
    "value": "Centroid",
    "description": "The central point of a cluster in a dataset, representing the average of all data points within that cluster, typically used in clustering algorithms like K-means where each cluster is characterized by its centroid, allowing data points to be assigned to the cluster with the closest centroid to them."
  },
  {
    "key": 63,
    "value": "Classification",
    "description": "A type of machine learning model that predicts a categorical value (like a T-shirt size) based on a set of input variables."
  },
  {
    "key": 64,
    "value": "Class Imbalance",
    "description": "A situation where a dataset used for training a model has a significantly uneven distribution of data points across different classes, meaning one class has a considerably larger number of samples compared to others, causing the model to potentially favor the majority class and perform poorly on the minority class when making predictions."
  },
  {
    "key": 65,
    "value": "Confusion Matrix",
    "description": "A table that visually represents how well a classification model is performing by showing the number of correct and incorrect predictions it makes, categorized as “True Positives,” “True Negatives,” “False Positives,” and “False Negatives.”"
  },
  {
    "key": 66,
    "value": "Converse API",
    "description": "A standardized interface within Amazon Bedrock that allows developers to interact with various text-based generative AI models (like chatbots) through a single, consistent API."
  },
  {
    "key": 67,
    "value": "Convolutional Neural Network (CNN)",
    "description": "A type of deep learning model particularly effective for processing data with a grid-like structure, such as images. CNNs use convolutional layers to automatically and adaptively learn spatial hierarchies of features from input images, making them highly effective for tasks like image classification, object detection, and image segmentation."
  },
  {
    "key": 68,
    "value": "Cross Validation",
    "description": "A technique used to evaluate the performance of a machine learning model by splitting the dataset into multiple subsets, training the model on a portion of the data, and bgloss.indd Page 398 09 Apr 2025 then testing it on the remaining portion, repeating this process with different data splits to get a more robust assessment of the model’s ability to generalize to unseen, new data and to prevent overfitting."
  },
  {
    "key": 69,
    "value": "Data Access Pattern",
    "description": "A method that defines how users and system access data to satisfy business needs."
  },
  {
    "key": 70,
    "value": "Data Augmentation",
    "description": "The process of artificially generating new data from existing data, primarily to train new machine learning models, and to improve their performance and ability to generalize to new, unseen data."
  },
  {
    "key": 71,
    "value": "Data Drift",
    "description": "Unexpected and undocumented changes in data structure, semantics, or infrastructure that can degrade the performance of machine learning models."
  },
  {
    "key": 72,
    "value": "Data Format",
    "description": "The structured way data is organized and stored, typically in a file format like comma-separated values (CSV), which allows the machine learning algorithms to easily read and interpret the information for training and prediction purposes."
  },
  {
    "key": 73,
    "value": "Data Labeling",
    "description": "The process of adding meaningful labels to raw data (like images, text, or video) to provide context and allow a machine learning model to learn from it, essentially giving the data a clear meaning so the model can make accurate predictions based on that information."
  },
  {
    "key": 74,
    "value": "Data Lake",
    "description": "A centralized repository where you can store structured, semi-structured and unstructured data, at any scale, without needing to pre-structure it."
  },
  {
    "key": 75,
    "value": "Data Leakage",
    "description": "A situation where a model is trained using information that wouldn’t be available at prediction time, leading to an artificially inflated accuracy during training and poor performance when deployed in real-world scenarios."
  },
  {
    "key": 76,
    "value": "Data Point",
    "description": "A single observation with multiple features that can be used by a model to identify patterns and make predictions based on the data provided."
  },
  {
    "key": 77,
    "value": "Dataset",
    "description": "A collection of data points stored within the AWS ecosystem, which is used to train and test machine learning models."
  },
  {
    "key": 78,
    "value": "Data Splitting",
    "description": "The process of dividing a dataset into multiple subsets, typically used for training, validating, and testing a machine learning model, where one part of the split is used to train the model, and the other parts are used to evaluate its performance on unseen data, ensuring the model generalizes well beyond the training data it was exposed to."
  },
  {
    "key": 79,
    "value": "DeepAR",
    "description": "An Amazon SageMaker AI built-in algorithm specifically designed for time series forecasting, utilizing recurrent neural networks (RNNs) to generate both point predictions and probabilistic forecasts. bgloss.indd Page 399 09 Apr 2025"
  },
  {
    "key": 80,
    "value": "Deep Neural Network",
    "description": "A type of neural network with multiple hidden layers between the input and output layers."
  },
  {
    "key": 81,
    "value": "Dimensionality",
    "description": "The number of features or variables present in a dataset, essentially representing the number of attributes used to describe each data point."
  },
  {
    "key": 82,
    "value": "Elastic Net Regularization",
    "description": "A technique that combines the strengths of both Lasso (L1) and Ridge (L2) regression by applying a penalty term to the loss function that includes a mix of both absolute value and squared sum of the model coefficients, allowing for both feature selection (like Lasso) and handling highly correlated features (like Ridge) effectively."
  },
  {
    "key": 83,
    "value": "Elbow Method",
    "description": "A heuristic technique used to determine the optimal number of clusters in a dataset when performing K-means clustering."
  },
  {
    "key": 84,
    "value": "Embedding",
    "description": "A numerical representation of real-world objects, like words, images, or products, which allows machine learning models to understand complex relationships between data points by converting them into vectors that capture semantic meaning."
  },
  {
    "key": 85,
    "value": "Endpoint",
    "description": "An interface used to expose machine learning models into applications for making predictions, or inferences. Endpoints support multiple inference types, including real-time inference, serverless inference (a cost-effective option for workloads with intermittent or unpredictable traffic), and asynchronous inference (designed for processing large or long-running requests). An endpoint has a configuration with properties such as model name, instance type, initial instance count, scaling settings, and a list of production variants. An endpoint provides a stable and scalable solution for various machine learning deployment scenarios."
  },
  {
    "key": 86,
    "value": "Epoch",
    "description": "A single complete pass through the entire training dataset during the model training process, where the model sees every data point once and updates its parameters based on that data cycle."
  },
  {
    "key": 87,
    "value": "Estimator",
    "description": "A high-level Python SDK object that allows you to manage the configuration and execution of a machine learning training job."
  },
  {
    "key": 88,
    "value": "F1 Score",
    "description": "A metric used to evaluate the performance of a classification model, combining both precision and recall into a single value, providing a balanced measure of how well a model identifies relevant instances while minimizing false positives."
  },
  {
    "key": 89,
    "value": "Facet",
    "description": "A specific feature within your data that you can use to analyze potential bias or disparities in your model’s predictions, essentially allowing you to examine how the model performs across different groups defined by that attribute, like gender, age, or location. bgloss.indd Page 400 09 Apr 2025"
  },
  {
    "key": 90,
    "value": "Factorization Machines",
    "description": "An Amazon SageMaker AI built-in algorithm designed to effectively capture interactions between features in large, sparse datasets, making it particularly useful for tasks like classification and regression, especially in scenarios like recommender systems."
  },
  {
    "key": 91,
    "value": "Feature",
    "description": "An individual measurable property extracted from data that is used as an input to a machine learning model during training and inference."
  },
  {
    "key": 92,
    "value": "Feature Engineering",
    "description": "The process of selecting and transforming variables (features) from raw data to create a set of features that are most relevant and informative for building a predictive model in machine learning."
  },
  {
    "key": 93,
    "value": "Feature Hashing",
    "description": "A technique used to transform categorical data into numerical data by mapping each unique category to a fixed-size numerical vector using a hash function, allowing for efficient processing of large datasets with a high number of potential categories."
  },
  {
    "key": 94,
    "value": "Foundation Model",
    "description": "A large AI model that’s trained on massive amounts of data. It’s a type of generative artificial intelligence (AI) that can be used to create new content, answer questions, and more."
  },
  {
    "key": 95,
    "value": "Generalizability",
    "description": "A model’s ability to accurately make predictions on new, unseen data that is similar to the data it was trained on, essentially meaning how well the model can apply what it learned from the training data to new situations, making it a crucial factor for real-world application and reliable performance."
  },
  {
    "key": 96,
    "value": "Gradient Descent",
    "description": "An optimization algorithm used in machine learning to train models by repeatedly adjusting their parameters (like weights and biases) in the direction that minimizes the loss function."
  },
  {
    "key": 97,
    "value": "Histogram",
    "description": "A visual representation that displays the distribution of a numerical variable within a dataset by dividing the data into “bins” and showing the frequency of values falling within each bin."
  },
  {
    "key": 98,
    "value": "Hyperparameter",
    "description": "A configuration variable that is set before training a model, controlling aspects like learning rate, model complexity, or the number of epochs, and directly impacts the performance of the model during training, but is not learned from the data itself."
  },
  {
    "key": 99,
    "value": "IAM User",
    "description": "A policy-based entity that you create in your AWS account, which represents a human user or an application allowing them to interact with AWS resources by granting them specific permissions to access and manage those resources. bgloss.indd Page 401 09 Apr 2025"
  },
  {
    "key": 100,
    "value": "IAM Group",
    "description": "A collection of IAM users with shared permissions."
  },
  {
    "key": 101,
    "value": "IAM Role",
    "description": "A policy-based entity that grants permissions to users and applications to perform actions in AWS. IAM roles are a security best practice because they provide temporary credentials."
  },
  {
    "key": 102,
    "value": "Identity",
    "description": "A representation of a human user or a programmatic workload that can be authenticated and authorized to perform actions within AWS accounts."
  },
  {
    "key": 103,
    "value": "Image Classification",
    "description": "A process that uses algorithms to categorize and label images."
  },
  {
    "key": 104,
    "value": "Image Data",
    "description": "Data that is presented in visual format, such as photos, diagrams, or other graphical content, which is used as input for training, validating, and testing machine learning models."
  },
  {
    "key": 105,
    "value": "Imputation",
    "description": "The process of replacing missing data points in a dataset with estimated values, allowing the analysis to proceed even when there are gaps in information."
  },
  {
    "key": 106,
    "value": "Inference",
    "description": "The process of using a trained machine learning model to make predictions on new data, essentially applying the model to real-world situations to generate outputs based on the patterns it learned during training."
  },
  {
    "key": 107,
    "value": "Ingestion",
    "description": "The process of collecting, importing, and transferring raw data from various sources into an AWS storage system like Amazon S3, where it can be further processed, cleaned, and prepared for analysis and use in machine learning models."
  },
  {
    "key": 108,
    "value": "Interpretability",
    "description": "The ability to understand how a machine learning model makes predictions, essentially allowing you to see which factors within the data most significantly influence the model’s output and why it reached a particular decision."
  },
  {
    "key": 109,
    "value": "IP Insights",
    "description": "An Amazon SageMaker AI built-in unsupervised learning algorithm that analyzes associations between entities (like user accounts) and their corresponding IP addresses, allowing you to identify potentially anomalous usage patterns or suspicious IP addresses."
  },
  {
    "key": 110,
    "value": "Jupyter Notebook",
    "description": "An interactive web-based environment, accessible through Amazon SageMaker AI, where machine learning engineers and data scientists can write and execute code, analyze data, visualize results, and document their machine learning workflow all within a single, organized document."
  },
  {
    "key": 111,
    "value": "K-Means",
    "description": "An Amazon SageMaker AI built-in unsupervised learning algorithm that groups data points into clusters based on their similarity, essentially dividing data into distinct groups where points within a cluster are more similar to each other than to points in other clusters. bgloss.indd Page 402 09 Apr 2025"
  },
  {
    "key": 112,
    "value": "K-Nearest Neighbors (k-NN)",
    "description": "An Amazon SageMaker AI built-in supervised learning algorithm that classifies new data points by comparing them to the closest existing labeled data points in the dataset, essentially predicting the class of a new data point based on the majority class of its “k” nearest neighbors."
  },
  {
    "key": 113,
    "value": "L1 Regularization (LASSO)",
    "description": "A technique used to prevent overfitting in models by penalizing the absolute values of a model’s coefficients, effectively pushing less important feature weights toward zero, leading to a sparse model where only the most impactful features are used."
  },
  {
    "key": 114,
    "value": "L2 Regularization (Ridge)",
    "description": "A technique used to prevent overfitting in models by penalizing large weights, essentially pushing the model toward smaller, more distributed weight values across features, which helps the model generalize better to unseen data."
  },
  {
    "key": 115,
    "value": "Label",
    "description": "The target value that the model is trying to identify within the data."
  },
  {
    "key": 116,
    "value": "Label Encoding",
    "description": "A technique used to convert categorical data into numerical data by assigning a unique integer to each category."
  },
  {
    "key": 117,
    "value": "Lag Feature",
    "description": "A feature created by taking the value of a variable at a previous time point and using it as an input feature in the current time step, essentially allowing the model to capture temporal dependencies and patterns within the data by looking at past values to predict future ones."
  },
  {
    "key": 118,
    "value": "Latent Dirichlet Allocation (LDA)",
    "description": "An Amazon SageMaker AI built-in unsupervised learning algorithm used for topic modeling that represents a document as a mixture of different topics with varying probabilities."
  },
  {
    "key": 119,
    "value": "Large Language Model (LLM)",
    "description": "A type of deep learning model trained on massive amounts of text data, allowing it to generate human-like text, answer questions, translate languages, summarize information, and perform other natural language processing tasks based on prompts or input given to it."
  },
  {
    "key": 120,
    "value": "Layer",
    "description": "A group of interconnected neurons that process information together, with the entire neural network typically consisting of an input layer, one or more hidden layers, and an output layer."
  },
  {
    "key": 121,
    "value": "Linear Model Deployment",
    "description": "A deployment strategy where new model versions are gradually rolled out to production by steadily increasing the percentage of traffic directed to the new model over time, allowing for continuous monitoring and minimizing risk by exposing only a small portion of users to the new version initially."
  },
  {
    "key": 122,
    "value": "Linear Learner",
    "description": "An Amazon SageMaker AI built-in supervised learning algorithm that is used to build linear models for both classification and regression tasks. bgloss.indd Page 403 09 Apr 2025"
  },
  {
    "key": 123,
    "value": "Logarithmic Transformation",
    "description": "A data preprocessing technique where each data point in a feature is replaced with its logarithm (either base 10 or natural log), essentially compressing the data scale, which is particularly useful for handling highly skewed data distributions, reducing the impact of outliers, and making the data more suitable for machine learning models by approximating a normal distribution."
  },
  {
    "key": 124,
    "value": "Logistic Function (also known as the Sigmoid Function)",
    "description": "A mathematical formula used within a Logistic Regression model to transform the input values into a probability score between 0 and 1, essentially indicating the likelihood of an event (“yes” or “no”) occurring."
  },
  {
    "key": 125,
    "value": "Logistic Regression",
    "description": "A statistical model used for binary classification tasks, which predicts the probability of an event (“yes” or “no”) occurring based on input variables."
  },
  {
    "key": 126,
    "value": "Loss Function",
    "description": "A mathematical function that measures the difference between a model’s predicted output and the actual target value."
  },
  {
    "key": 127,
    "value": "Mean",
    "description": "The average value of a set of data points, calculated by adding up all the values and dividing by the total number of data points."
  },
  {
    "key": 128,
    "value": "Model",
    "description": "A mathematical representation of patterns learned from data, which can be used to make predictions on new data."
  },
  {
    "key": 129,
    "value": "Model Deployment",
    "description": "The process of taking a trained machine learning model and making it accessible in a production environment (on AWS), allowing it to receive new data and generate predictions that can be used by applications or other systems."
  },
  {
    "key": 130,
    "value": "Model Drift",
    "description": "The phenomenon where a machine learning model’s performance gradually declines over time due to changes in the data distribution it is being used on, leading to less accurate predictions as the model becomes less aligned with the evolving real-world data."
  },
  {
    "key": 131,
    "value": "Model Evaluation",
    "description": "The process of assessing how well a trained machine learning model performs on a given dataset by using various metrics to understand its strengths and weaknesses."
  },
  {
    "key": 132,
    "value": "Model Monitoring",
    "description": "The process of continuously tracking the performance of a deployed machine learning model in production using Amazon SageMaker Model Monitor."
  },
  {
    "key": 133,
    "value": "Multi-Container Endpoint (MCE)",
    "description": "A deployment option that enables hosting multiple containerized applications or machine learning models on a single endpoint. Each container can run a different model or application, and incoming inference requests are routed to the appropriate container based on a specified inference execution configuration (serial or direct). This setup provides flexibility, efficient resource utilization, and simplified management for serving diverse models from a single endpoint. bgloss.indd Page 404 09 Apr 2025"
  },
  {
    "key": 134,
    "value": "Multi-Model Endpoint (MME)",
    "description": "A deployment option that allows multiple machine learning models to share the same container image hosted on a single endpoint. The models are loaded into memory on demand, sharing the same infrastructure. This approach reduces operational costs and simplifies the management of multiple models, making it ideal for scenarios where individual models are infrequently accessed."
  },
  {
    "key": 135,
    "value": "Natural Language Processing (NLP)",
    "description": "A technology that allows computers to understand and interpret human language, enabling them to analyze and process text data like emails, reviews, or social media posts to extract meaning, sentiment, and key information, often used for tasks like sentiment analysis, chatbots, and text classification."
  },
  {
    "key": 136,
    "value": "Neural Network",
    "description": "A type of machine learning model, inspired by the human brain, that uses interconnected nodes (neurons) arranged in layers to process data and learn complex patterns."
  },
  {
    "key": 137,
    "value": "Neural Topic Model (NTM)",
    "description": "An Amazon SageMaker AI built-in unsupervised learning algorithm that automatically identifies and extracts recurring themes (topics) from a collection of documents by analyzing word distributions, allowing you to categorize and understand the underlying semantic content of large text datasets without predefining the topics beforehand."
  },
  {
    "key": 138,
    "value": "Noise",
    "description": "Random or unpredictable fluctuations in data that disrupt a model’s ability to identify clear patterns, essentially meaning irrelevant or erroneous information within your dataset that can negatively impact the accuracy of your machine learning model’s predictions."
  },
  {
    "key": 139,
    "value": "Nova",
    "description": "A family of state-of-the-art foundation models developed by Amazon, designed to handle a wide range of AI tasks like text generation, video analysis, and content creation."
  },
  {
    "key": 140,
    "value": "Normalization",
    "description": "A data preprocessing technique where numerical values within a dataset are scaled to a common range, typically between 0 and 1, ensuring that all features have equal importance regardless of their original scale."
  },
  {
    "key": 141,
    "value": "Numerical Data",
    "description": "Data that is represented by numbers, meaning it can be measured and expressed as a quantitative value, like temperature, weight, or sales figures."
  },
  {
    "key": 142,
    "value": "Object Detection",
    "description": "A computer vision technique that identifies and locates specific objects within an image or video, using bounding boxes to pinpoint their position, essentially allowing the system to not only classify what objects are present, but also where they are situated within the frame. bgloss.indd Page 405 09 Apr 2025"
  },
  {
    "key": 143,
    "value": "One-Hot Encoding",
    "description": "A technique used to convert categorical data into a binary (0s and 1s) format. Each distinct category is transformed into a new binary column, where the presence of the category is marked with a 1, and the absence is marked with a 0."
  },
  {
    "key": 144,
    "value": "Outlier",
    "description": "A data point that significantly deviates from the majority of the data in a dataset, meaning it stands out as an unusual or extreme value compared to the overall pattern, which can potentially affect the accuracy of a machine learning model if not properly handled."
  },
  {
    "key": 145,
    "value": "Overfitting",
    "description": "A situation where a model performs exceptionally well on the training data it was trained on, but performs poorly on new, unseen data (test data), indicating that the model has learned the noise and specific details of the training data too closely, rather than the underlying patterns, leading to poor generalization ability on new examples."
  },
  {
    "key": 146,
    "value": "Oversampling",
    "description": "A data augmentation technique used to address class imbalance in a dataset by artificially increasing the number of samples belonging to the minority class, essentially creating more copies of existing data points or generating synthetic data to better represent the underrepresented class and improve model performance when dealing with imbalanced datasets."
  },
  {
    "key": 147,
    "value": "Parameter",
    "description": "An internal variable within a machine learning model that is automatically learned from the training data, defining how the model transforms input data into predictions, and is not manually set by the user."
  },
  {
    "key": 148,
    "value": "Permission Boundary",
    "description": "An AWS IAM feature that allows to set the maximum permissions an IAM entity (user or role) can have."
  },
  {
    "key": 149,
    "value": "Precision",
    "description": "A performance metric that measures the proportion of correct positive predictions made by a model out of all the predictions it classified as positive."
  },
  {
    "key": 150,
    "value": "Prediction",
    "description": "The outcome or result generated by a trained machine learning model when it analyzes new data, essentially forecasting a future value or category based on patterns learned from historical, training data."
  },
  {
    "key": 151,
    "value": "Principal",
    "description": "A person or an application authenticated using an IAM user or an IAM role."
  },
  {
    "key": 152,
    "value": "Principal Component Analysis (PCA)",
    "description": "An Amazon SageMaker AI built-in unsupervised learning algorithm used to reduce the dimensionality of large datasets by transforming a large set of features into a smaller set, while still preserving most of the important information, essentially finding the most significant patterns within the data by identifying the directions of maximum variance."
  },
  {
    "key": 153,
    "value": "Production Variant",
    "description": "A model configuration deployed to an endpoint for hosting. It includes details such as the model name, instance type, initial instance count, and traffic distribution bgloss.indd Page 406 09 Apr 2025 weight. Production variants allow you to manage multiple models or versions under a single endpoint, enabling tasks like blue/green, canary, linear deployments or A/B testing."
  },
  {
    "key": 154,
    "value": "Quartile",
    "description": "A statistical term that refers to one of the four equal groups into which a dataset is divided when ordered from least to greatest. A quartile splits the dataset into “quarters” with the first quartile representing the lowest 25%, the second quartile being the median, and the third quartile representing the highest 25% of the dataset."
  },
  {
    "key": 155,
    "value": "Random Cut Forest (RCF)",
    "description": "An Amazon SageMaker AI built-in unsupervised learning algorithm primarily used for anomaly detection, where it identifies data points that significantly deviate from the normal pattern within a dataset, often applied to streaming data."
  },
  {
    "key": 156,
    "value": "Real-time Inference",
    "description": "The process of deploying a trained model to an endpoint that can provide immediate predictions based on incoming data."
  },
  {
    "key": 157,
    "value": "Recall",
    "description": "A performance metric that measures how well a model identifies all relevant positive instances within a dataset."
  },
  {
    "key": 158,
    "value": "Rectified Linear Unit (ReLU)",
    "description": "A commonly used activation function in neural networks that outputs the input value if it’s positive, and outputs zero for any negative input, essentially introducing nonlinearity to the model and helping it learn complex patterns in data."
  },
  {
    "key": 159,
    "value": "Recurrent Neural Network (RNN)",
    "description": "A type of deep learning model specifically designed to process sequential data, like text, audio, or time series information, by utilizing an internal memory to remember previous inputs and leverage that information when making predictions on current data points within a sequence."
  },
  {
    "key": 160,
    "value": "Regression",
    "description": "A type of machine learning model that predicts a continuous numerical value (like price, temperature, or sales) based on a set of input variables."
  },
  {
    "key": 161,
    "value": "Regularization",
    "description": "A technique used to prevent overfitting in machine learning models by adding a penalty term to the loss function."
  },
  {
    "key": 162,
    "value": "Reinforcement Learning",
    "description": "A type of machine learning where an agent learns to make decisions by performing actions in an environment to maximize cumulative rewards."
  },
  {
    "key": 163,
    "value": "Retrieval Augmented Generation (RAG)",
    "description": "A technique that enhances the capabilities of a large language model (LLM) by allowing it to access and reference external knowledge sources, like a company’s internal database or document repository, before generating responses. bgloss.indd Page 407 09 Apr 2025"
  },
  {
    "key": 164,
    "value": "Rolling Windows Feature",
    "description": "A feature extracted from time-series data by calculating a statistic (like average, sum, or standard deviation) over a continuously moving “window” of past data points, allowing you to capture recent trends or patterns within the data as it progresses through time."
  },
  {
    "key": 165,
    "value": "Scaling Policy",
    "description": "A set of rules or configurations that determine how the number of instances behind an Amazon SageMaker AI endpoint adjusts automatically based on workload demands. There are three main types of scaling policies: target tracking, step scaling, and scheduled scaling."
  },
  {
    "key": 166,
    "value": "Scheduled Scaling",
    "description": "A scaling policy type that automatically adjusts the number of instances (serving a machine learning model) at specific times or intervals based on a preconfigured schedule."
  },
  {
    "key": 167,
    "value": "Semantic Segmentation Algorithm",
    "description": "An Amazon SageMaker AI built-in algorithm that tags every pixel in an image with a class label from a predefined set of classes, commonly used in computer vision applications, such as self-driving vehicles, medical imaging diagnostics, and robot sensing."
  },
  {
    "key": 168,
    "value": "Semi-structured Data",
    "description": "Data that has some inherent structure, like tags or key-value pairs, but doesn’t strictly follow a rigid relational database schema like structured data."
  },
  {
    "key": 169,
    "value": "Sequence-to-Sequence",
    "description": "A type of neural network architecture used for tasks where the input and output are both sequences of data, like translating text from one language to another, summarizing text, or generating captions for images; essentially transforming one sequence into another sequence, making it a powerful tool for natural language processing (NLP) applications."
  },
  {
    "key": 170,
    "value": "Serverless Inference",
    "description": "A feature within Amazon SageMaker AI that allows you to deploy and serve machine learning models for real-time prediction without needing to manage the underlying compute infrastructure."
  },
  {
    "key": 171,
    "value": "Service Control Policy (SCP)",
    "description": "A set of rules that controls permissions for users and roles in an organization. SCPs are used to enforce security standards across multiple AWS accounts."
  },
  {
    "key": 172,
    "value": "Skewness",
    "description": "An uneven distribution of data within a dataset, where one side of the data distribution has a longer tail compared to the other, meaning the data is not symmetrically distributed around its mean, which can negatively impact the performance of machine learning models if not addressed properly."
  },
  {
    "key": 173,
    "value": "Specificity",
    "description": "A metric used to evaluate the accuracy of a model’s negative predictions. It measures the proportion of true negative predictions out of all the negative predictions made by the model. bgloss.indd Page 408 09 Apr 2025"
  },
  {
    "key": 174,
    "value": "Standard Deviation",
    "description": "A statistical measure that indicates how spread out a set of data points are from their mean (average), essentially showing how much variation exists within a dataset."
  },
  {
    "key": 175,
    "value": "Standardization",
    "description": "A data preprocessing technique where numerical features in a dataset are transformed to have a mean of 0 and a standard deviation of 1, essentially scaling all features to a consistent range, making it easier for machine learning algorithms to process and compare different variables within the data."
  },
  {
    "key": 176,
    "value": "Stemming",
    "description": "A natural language processing (NLP) technique where words are reduced to their root form by removing suffixes, essentially creating a base version of the word, which is often used as a preprocessing step to clean and normalize text data before feeding it into a machine learning model."
  },
  {
    "key": 177,
    "value": "Step Scaling",
    "description": "A scaling policy type that automatically adjusts the number of instances (serving a machine learning model) based on predefined steps that you define in response to a target threshold triggering event (e.g., the lower bound, the upper bound, and the amount by which to scale)."
  },
  {
    "key": 178,
    "value": "Stochastic Gradient Descent (SGD)",
    "description": "An optimization algorithm used to train models by iteratively updating the model parameters based on the gradient calculated from a single random data point at each step, allowing for efficient training on large datasets by processing data one example at a time, rather than the entire dataset simultaneously."
  },
  {
    "key": 179,
    "value": "Storage",
    "description": "The service used to store the data needed for training and evaluating machine learning models."
  },
  {
    "key": 180,
    "value": "Structured Data",
    "description": "Data that is organized in a well-defined schema, usually in rows and columns, with clear labels for each data point, making it easy for computers to process and analyze, often stored in a relational database."
  },
  {
    "key": 181,
    "value": "Supervised Learning",
    "description": "A type of machine learning where algorithms are trained using labeled datasets, meaning each data point has a known actual output; essentially, the model is “supervised” by the labeled data to learn the correct answer."
  },
  {
    "key": 182,
    "value": "Support Vector Machines",
    "description": "A supervised machine learning algorithm used for classification and regression tasks, which aims to find the optimal “hyperplane” to separate data points into different classes by maximizing the margin between the hyperplane and the closest data points (called support vectors), effectively allowing for the best possible distinction between data categories."
  },
  {
    "key": 183,
    "value": "Synthetic Data",
    "description": "Artificially generated data created by computer algorithms that mimics the characteristics of real-world data, allowing developers to train machine learning models without relying entirely on sensitive or hard-to-obtain real data, while still preserving important statistical patterns and properties from the original dataset."
  },
  {
    "key": 184,
    "value": "Synthetic Minority Over-sampling Technique (SMOTE)",
    "description": "A data manipulation method used to address class imbalance in datasets by generating synthetic data points for the minority bgloss.indd Page 409 09 Apr 2025 class, effectively balancing the distribution between different classes and improving the performance of machine learning models trained on such data."
  },
  {
    "key": 185,
    "value": "Target Tracking",
    "description": "A scaling policy type that automatically adjusts the number of instances (serving a machine learning model) to maintain a specific target value for a predefined metric, such as average CPU utilization, average request count per target (for use with application load balancers), and others."
  },
  {
    "key": 186,
    "value": "Test Data",
    "description": "A dataset (distinct from the training dataset) used to evaluate the performance of a trained machine learning model on unseen data, allowing you to assess its accuracy and reliability on real-world scenarios."
  },
  {
    "key": 187,
    "value": "Textual Data",
    "description": "Data that is presented in text format, like emails, social media posts, customer reviews, or documents, which can be analyzed using natural language processing (NLP) techniques to extract meaningful insights and patterns from the written content."
  },
  {
    "key": 188,
    "value": "Time-Series Data",
    "description": "A sequence of data points collected at regular intervals over time, where each point is associated with a specific timestamp, allowing you to analyze trends, patterns, and changes in data over a period, such as monitoring sensor readings from a machine, tracking daily sales figures, or recording website traffic statistics at regular intervals."
  },
  {
    "key": 189,
    "value": "Tokenization",
    "description": "The process of replacing sensitive data with a random string of characters called a “token,” which holds no intrinsic value but acts as a reference to the original data, significantly reducing security risks by preventing direct exposure of sensitive information within the system."
  },
  {
    "key": 190,
    "value": "Training Data",
    "description": "A dataset used to teach a machine learning model by providing it with labeled examples, allowing the model to learn patterns and relationships within the data, which it can then use to make predictions on new, unseen data."
  },
  {
    "key": 191,
    "value": "Underfitting",
    "description": "A situation where a model is too simple to effectively capture the patterns in the training data, resulting in poor performance on both the training and test sets."
  },
  {
    "key": 192,
    "value": "Undersampling",
    "description": "A technique used to balance imbalanced datasets by randomly removing samples from the majority class, effectively reducing its size to better match the minority class, allowing the machine learning model to learn more effectively from both classes."
  },
  {
    "key": 193,
    "value": "Unstructured Data",
    "description": "Data that doesn’t fit into a predefined data model or schema, meaning it doesn’t have a structured format like a traditional database table. bgloss.indd Page 410 09 Apr 2025"
  },
  {
    "key": 194,
    "value": "Unsupervised Learning",
    "description": "A type of machine learning where the algorithm analyzes unlabeled data, meaning it doesn’t have actual target values, as a reference or “truth” to discover hidden patterns and relationships within the data."
  },
  {
    "key": 195,
    "value": "Variance",
    "description": "A machine learning model’s sensitivity to fluctuations in the training data. High variance means the model is too complex and captures noise along with the underlying patterns, leading to overfitting."
  },
  {
    "key": 196,
    "value": "Weight",
    "description": "A numerical value assigned to a data point or feature within a training dataset, essentially indicating how much influence that specific data point or feature should have on the model’s learning process."
  },
  {
    "key": 197,
    "value": "Word2Vec",
    "description": "A neural network-based algorithm that generates “word embeddings,” which are numerical representations of words, allowing the system to understand the semantic relationships between words by placing similar words close together in a vector space."
  },
  {
    "key": 198,
    "value": "XGBoost (eXtreme Gradient Boosting)",
    "description": "An Amazon SageMaker AI built-in supervised learning algorithm, which provides a highly optimized implementation of the gradient boosting trees algorithm, often used for classification and regression tasks."
  },
  {
    "key": 199,
    "value": "YOLO",
    "description": "A computer vision algorithm used for real-time object detection, allowing you to quickly identify multiple objects within an image by processing it only once; it’s often utilized on Amazon SageMaker AI to deploy and scale object detection models with high speed and accuracy."
  },
  {
    "key": 200,
    "value": "Z-score",
    "description": "A statistical measure that indicates how many standard deviations a data point is away from the mean, essentially showing how far a specific value is from the average within a dataset, expressed in terms of standard deviations."
  }
];
